module.exports = __webpack_public_path__ + "static/media/contact_right.498cb1ac.jpg";